import * as $ from "jquery";
import * as _ from "lodash";
import * as moment from "moment-timezone";
import "select2";
import { ModuleCollection } from "../../../../../collections/Modules";
import { TimezoneCollection } from "../../../../../collections/Timezones";
import { Utils } from "../../../../../common/utils";
import { DashboardChannel } from "../../../../../models/DashboardChannel";
import {
    CHART_DATA_RANGE,
    CHART_HIDE_EXPORTS,
    CHART_LABELS,
    CHART_REAL_TIMESTAMPS,
    CHART_THRESHOLDS,
    CHART_TYPE,
    ChartHelper,
    DAILY_TIME_MODE
} from "../../../../dashboard/widgets/chart/ChartHelper";
import {
    BaseModifyDashboardWidgetView,
    BaseModifyDashboardWidgetViewOptions,
    NewDashboardChannel
} from "../_BaseModifyWidgetView";

declare var App: any;
require('bootstrap-datetimepicker');


export class ModifyChartWidgetView extends BaseModifyDashboardWidgetView {

    private widgetChannels: DashboardChannel[];
    private template = _.template(require('templates/modals/dashboard/modify_widgets/chart/chart.html'));
    private channelsTemplate = _.template(require('templates/modals/dashboard/modify_widgets/shared/channels.html'));
    private channelFieldTemplate = _.template(require('templates/modals/dashboard/modify_widgets/shared/channel_field.html'));
    private dateTimePickerFormat = 'MM/DD/YYYY h:mm A';
    private dailyTimeFormat = 'hh:mm A';

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any>_.extend({
            tagName: "div",
            className: 'widget-type-chart',
            events: {
                'change .chart-type select': 'handleChartTypeChange',
                'change .aggregation-period select': 'handleAggregationPeriodChange',
                'change .show-thresholds select': 'handleShowThresholdsChange',
                'change .data-range select': 'handleDataRangeChange',
                'change .show-labels select': 'handleShowLabelsChange',
                'click .add-channel-btn': 'handleAddChannelBtnClick',
                'change .aggregation-wrapper select': 'handleChangeAggregationType',
                'change .tab select': 'handleTabChange',

                // Chart Channel Changes
                'change .widget-channel-select-install': 'handleInstallSelectChange',
                'change .widget-channel-select-module': 'handleModuleSelectChange',
                'change .widget-channel-select-channel': 'handleChannelSelectChange',
                'click .widget-channel-delete': 'handleChannelDelete',
                'click .thresholds-minimized': 'handleThresholdClick',
                'input .thresholds input': 'handleThresholdsInput',
                'input .gauge-lower-limit input': 'handleLimitInput',
                'input .gauge-upper-limit input': 'handleLimitInput',
                'input .has-warning': 'handleLimitInput',
                'input .has-danger': 'handleLimitInput',
                'change .custom-labels-config-checkbox': 'handleCustomLabelsToggleChange',

                // Ranges
                'change .advanced-config-checkbox': 'handleConfigToggleChange',
                'click .add-threshold-btn': 'handleAddThreshold',
                'click .delete-threshold-btn, .delete-threshold-btn-mobile': 'handleDeleteThreshold',
                'input .threshold-name, .threshold-value': 'handleThresholdInput',
                'click .use-defaults-btn': 'handleUseDefaultsBtn',
            }
        }, options));

        this.widgetChannels = null;
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: [
                    { key: 'CHART_TITLE', value: '' },
                    { key: 'CHART_TYPE', value: '1' },
                    { key: 'CHART_SIZE', value: '2' },
                    { key: 'CHART_CONNECT_TO_TILES', value: '2' },
                    { key: 'CHART_THRESHOLDS', value: '1' },
                    { key: 'CHART_TIMESTAMPS', value: '1' },
                    { key: 'CHART_AGGREGATION_TYPE', value: '1' },
                    { key: 'CHART_AGGREGATION_PERIOD', value: '0' },
                    { key: 'CHART_LABELS', value: '2' },
                    { key: 'CHART_DATA_RANGE', value: '2' },
                    { key: 'CHART_DATA_ZOOM', value: '2' },
                    { key: 'CHART_TIMEZONE', value: this.options.currentUser.get('timezone') },
                ]
            });
            this.widgetChannels = [];
        } else {
            this.widgetChannels = this.options.dashboardChannelCollection.where({
                dashboard_widget_id: this.options.widget.get('id')
            });
        }
    }

    render() {
        const rawUseCustomLabelsConfig = this.options.widget.getParamValue('USE_CUSTOM_LABELS', true);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.useCustomLabels = !!Number(rawUseCustomLabelsConfig);

        this.$el.html(this.template({
            dashboardCategoriesCollection: this.options.dashboardCategoryCollection,
            dashboardTabCollection: this.options.dashboardTabCollection,
            widget: this.options.widget,
            c_stacked_bar_hour_url: require('../../../../../../img/widgettypes/charts/c_stacked_bar_1hour.png'),
            categoryId: this.options.widget.get('dashboard_category_id') ?
                this.options.widget.get('dashboard_category_id') : this.options.categoryId,
            tabId: this.options.tabId,
            timezones: new TimezoneCollection(),
            currentUser: this.options.currentUser,
            dateTimePickerFormat: this.dateTimePickerFormat,
            dailyTimeFormat: this.dailyTimeFormat,
            moment: moment,
            report: this.options.report,
            useCustomLabels: this.useCustomLabels
        }));

        this.$('select').select2(Utils.Select2.defaultOptions);

        const rawAdvancedConfig = this.options.widget.getParamValue('ADVANCED_CONFIG', false);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.advancedConfig = !!Number(rawAdvancedConfig);

        if (!this.options.widget.isNew()) {
            this.buildInitialChannels();
        } else {
            this.options.parentView.setSavable(false);
            var field = this.renderNewFieldRow();
            this.renderNewChannelRow(field);
            this.delegateEvents();
        }
        this.switchExampleImg();
        this.switchAggPeriod();
        this.handleChartTypeChange();
        this.handleDataRangeChange();
        this.setUpUIElements();

        return this;
    }

    show() {
        // Refit selects to container width after it is rendered on screen
        (<any>this.$('select')).select2(Utils.Select2.defaultOptions);
        this.$('.tab select').select2(Utils.Select2.defaultOptions);
        this.initializeCategorySelect('.category select');
    }

    handleTabChange(e: JQuery.Event) {
        var $select = this.$('.tab select');
        var rawValue = $select.val();
        var tabId = rawValue === '' || rawValue === null || rawValue === undefined ? null : Number(rawValue);
        this.options.tabId = tabId;
        this.reloadCategoriesForTab(tabId);
    }

    private buildInitialChannels() {
        var widgetId = this.options.widget.get('id');
        var channels = <DashboardChannel[]>this.options.dashboardChannelCollection.where({ dashboard_widget_id: widgetId });
        var aggTypes = this.options.widget.getParamValue('CHART_AGGREGATION_TYPE', '').split(',');
        _.each(_.groupBy(channels, (c: DashboardChannel) => {
            return c.get('dashboard_channel_secondary_order')
        }), (field: any[]) => {
            var fieldRow = this.renderNewFieldRow();
            _.each(field, (c: DashboardChannel) => {
                var installId = c.get('install_id');
                // Use channel's installId, rather than relying on App.getLastSelectedInstallId(), which caused errors
                var row = this.renderNewChannelRow(fieldRow, installId);

                var selectModuleChannel = (row) => {
                    // Select the module
                    row.find('.widget-channel-select-module').val(c.get('module_number')).trigger('change');

                    // Select the channel
                    row.find('.widget-channel-select-channel').val(c.get('channel_id')).trigger('change');
                };

                // Fill in the Dashboard Channel Id
                row.find('.widget-dashboard-channel-id').val(c.get('dashboard_channel_id'));

                // Select the install
                row.find('.widget-channel-select-install').val(installId).trigger('change');
                row.find('.widget-channel-select-channel').data('channelId', c.get('channel_id'));

                var moduleCollectionDeferred = this.options.moduleCollections[installId].getCollectionFetchPromise();
                $.when(moduleCollectionDeferred).done(() => {
                    selectModuleChannel(row);
                });
                if (!this.options.moduleCollections[installId]) {
                    row.hide();
                }

                var aggType = aggTypes[Number(c.get('dashboard_channel_order'))];
                row.find('.widget-channel-select-aggregation-type').val(aggType).trigger('change');
            });
        })

    }

    private setUpUIElements() {
        // Set up toggle button for chart exports
        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();

        var toggleButtons = [
            { paramString: 'CHART_HIDE_EXPORTS', className: '.chart-hide-exports' },
            { paramString: 'CHART_THRESHOLDS', className: '.chart-thresholds' },
            { paramString: 'CHART_LABELS', className: '.show-labels' },
            { paramString: 'CHART_TIMESTAMPS', className: '.chart-timestamps' },
            { paramString: 'DAILY_TIME_MODE', className: '.daily-time-mode' }
        ];

        _.each(toggleButtons, (button) => {
            var toggleButton = this.$(<string>button.className + ' input');
            var paramValue: number = Number(this.options.widget.getParamValue(<string>button.paramString, '0'));

            // Make an exception for CHART_HIDE_EXPORTS, because it toggles "active" when it is disabled
            var toggleCondition: boolean;
            if (button.paramString === 'CHART_HIDE_EXPORTS') {
                toggleCondition = paramValue < 2;
            } else {
                toggleCondition = paramValue >= 2;
            }

            if (toggleCondition) {
                (<any>toggleButton).bootstrapToggle('off');
            } else {
                (<any>toggleButton).bootstrapToggle('on');
            }
        });

        // Set up date selectors for custom data range
        var from = (<any>this.$('.data-range-custom-from .date'));
        var to = (<any>this.$('.data-range-custom-to .date'));
        // And for custom daily time
        var dailyCustomStart = (<any>this.$('.daily-time-custom-from'));
        var dailyCustomEnd = (<any>this.$('.daily-time-custom-to'));

        from.datetimepicker({
            defaultDate: moment().startOf('day')
        });
        to.datetimepicker({
            defaultDate: moment().endOf('day'),
            useCurrent: false
        });
        from.on("dp.change", function (e) {
            to.data("DateTimePicker").minDate(e.date);
        });
        to.on("dp.change", function (e) {
            from.data("DateTimePicker").maxDate(e.date);
        });

        dailyCustomStart.datetimepicker({
            defaultDate: moment(),
            format: this.dailyTimeFormat
        });
        dailyCustomEnd.datetimepicker({
            defaultDate: moment(),
            format: this.dailyTimeFormat
        });
    }

    private handleChangeAggregationType() {
        this.checkSavable();
    }

    private handleChartTypeChange() {
        this.switchExampleImg();

        var chartType = this.$('.chart-type select').val();
        var all = [
            '.show-thresholds', '.timestamps', '.aggregation-wrapper', '.show-labels',
            '.line-description', '.bar-description', '.stacked-bar-description',
            '.heatmap-description', '.stacked-area-description', '.all-options-description',
            '.pie-description', '.data-range', '.data-zoom', '.combo-description',
            '.channel-thresholds', '.chart-hide-exports', '.gauge_limits', '.add-channel-btn',
            '.widget-channel-delete', '.timezone', '.gauge-description', '.boxplot-description',
            '.advanced-configuration', '.title-line'
        ];

        var show, showThresholds, requireAggregation, chartNames;

        switch (chartType) {
            case '0':
                // Deprecated All Options setting
                break;
            case '1':
                show = ['.aggregation-wrapper', '.channel-thresholds', '.advanced-configuration', '.title-line', '.show-thresholds', '.timestamps',
                    '.line-description', '.data-range', '.data-zoom', '.chart-hide-exports', '.add-channel-btn',
                    '.widget-channel-delete', '.timezone'];
                showThresholds = true;
                requireAggregation = false;
                break;
            case '2':
                show = ['.aggregation-wrapper', '.show-labels', '.bar-description', '.data-range',
                    '.data-zoom', '.chart-hide-exports', '.add-channel-btn', '.widget-channel-delete', '.timezone'];
                showThresholds = false;
                requireAggregation = true;
                break;
            case '3':
                show = ['.aggregation-wrapper', '.show-labels', '.stacked-bar-description', '.data-range',
                    '.data-zoom', '.chart-hide-exports', '.add-channel-btn', '.widget-channel-delete', '.timezone'];
                showThresholds = false;
                requireAggregation = true;
                break;
            case '4':
                show = ['.aggregation-wrapper', '.show-labels', '.heatmap-description', '.data-range',
                    '.data-zoom', '.chart-hide-exports', '.add-channel-btn', '.widget-channel-delete', '.timezone'];
                showThresholds = false;
                requireAggregation = true;
                break;
            case '5':
                show = ['.aggregation-wrapper', '.stacked-area-description', '.data-range',
                    '.data-zoom', '.chart-hide-exports', '.add-channel-btn', '.widget-channel-delete', '.timezone'];
                showThresholds = false;
                requireAggregation = false;
                break;
            case '6':
                show = ['.show-labels', '.aggregation-wrapper', '.pie-description', '.data-range',
                    '.chart-hide-exports', '.add-channel-btn', '.widget-channel-delete', '.timezone'];
                showThresholds = false;
                requireAggregation = true;
                break;
            case '1,2':
                show = ['.show-labels', '.aggregation-wrapper', '.show-thresholds', '.channel-thresholds',
                    '.advanced-configuration', '.title-line', '.timestamps', '.combo-description', '.data-range',
                    '.data-zoom', '.chart-hide-exports', '.add-channel-btn', '.widget-channel-delete', '.timezone'];
                showThresholds = true;
                requireAggregation = true;
                chartNames = ['Line', 'Bar'];
                break;
            case '1,3':
                show = ['.show-labels', '.aggregation-wrapper', '.show-thresholds', '.channel-thresholds',
                    '.advanced-configuration', '.title-line', '.timestamps', '.combo-description', '.data-range',
                    '.data-zoom', '.chart-hide-exports', '.add-channel-btn', '.widget-channel-delete', '.timezone'];
                showThresholds = true;
                requireAggregation = true;
                chartNames = ['Line', 'Stacked Bar'];
                break;
            case '9':
                show = ['.aggregation-wrapper', '.channel-thresholds', '.advanced-configuration', '.title-line', '.gauge_limits', '.gauge-description'];
                showThresholds = true;
                requireAggregation = false;
                break;
            case '10':
                show = ['.aggregation-wrapper', '.show-labels', '.channel-thresholds', '.advanced-configuration',
                    '.title-line', '.boxplot-description', '.data-range', '.data-zoom', '.chart-hide-exports',
                    '.add-channel-btn', '.widget-channel-delete', '.timezone'];
                showThresholds = true;
                requireAggregation = true;
                break;
        }

        _.each(all, (klass) => {
            this.$(klass).toggleClass('hidden', !_.includes(show, klass));
        });

        this.$('.channels').toggleClass('line', showThresholds);

        // Disable the 'none' aggregation period if aggregation is required and select the first aggregation level
        // if none was selected
        var aggregationPeriod = this.$('.aggregation-period select').val();
        this.$('.aggregation-period option[value="0"]').prop('disabled', requireAggregation);
        try {
            this.$('.aggregation-period select').select2('destroy');
        } catch (e) {
        }
        this.$('.aggregation-period select').select2(Utils.Select2.defaultOptions);
        if (requireAggregation && aggregationPeriod === '0') {
            if (chartType == '10')
                this.$('.aggregation-period option[value="2"]').prop('selected', true).trigger('change');
            else
                this.$('.aggregation-period option[value="1"]').prop('selected', true).trigger('change');
        }

        this.setChannelFields(String(chartType).split(',').length, String(chartType), chartNames);
    }

    private setChannelFields(n: number, chartType:string, names: string[]) {
        const type = chartType.split(',');
        const fields: any = this.$('.channel-field');
        const max = Math.max(fields.length, n);
        //Create or remove field rows according to n required
        for (let i = 0; i < max; i++) {
            let field = fields.eq(i);
            if (n <= i) {
                field.remove();
            } else if (n > i && i >= fields.length) {
                field = this.renderNewFieldRow();
                this.renderNewChannelRow(field);
            }
            //Only show thresholds for first chart type, line
            if (i > 0) field.find('.channel-thresholds, .advanced-configuration, .title-line').addClass('hidden');
            const text = names ? names[i] : '';
            field.find('.chart-type-channel-text').text(text);
            // set chart type id as identificator
            field.find('.channels').attr('data-chart-id', type[i]);
        }
        this.switchAggPeriod();
    }

    private renderNewFieldRow() {
        var fieldRow = $(<string>this.channelFieldTemplate({
            advancedConfig: this.advancedConfig
        }));
        this.$('.all-channel-fields').append(fieldRow);

        //Initialize bootstrap toggle for advanced configuration
        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();
        return fieldRow;
    }

    private renderNewChannelRow(field, installId?: number) {
        var newChannelRow = $(<string>this.channelsTemplate({
            organizationCollection: this.options.organizationCollection,
            installCollection: this.options.installCollection,
            lastSelectedInstallId: installId || App.getLastSelectedInstallId(),
            report: this.options.report,
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels
        }));
        field.children('.channels').append(newChannelRow);

        newChannelRow.find('.widget-channel-select-install').select2(Utils.Select2.defaultOptions);
        newChannelRow.find('.widget-channel-select-module').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));
        newChannelRow.find('.widget-channel-select-channel').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));
        newChannelRow.find('.widget-channel-select-aggregation-type').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));

        // Immediately trigger a change so that preselected installs cause modules to be fetched
        newChannelRow.find('.widget-channel-select-install').trigger('change');
        this.delegateEvents();
        return newChannelRow;
    }


    private handleAddChannelBtnClick(e) {
        e.preventDefault();
        var field = this.$(e.currentTarget).parents('.channel-field');
        this.renderNewChannelRow(field);
        this.switchAggPeriod();
        this.checkSavable();
    }

    private buildModuleOptions(installId) {
        var options = [];
        this.options.moduleCollections[installId].each((module) => {

            // Filter Modules that don't have sensors connected. Control sensors are not
            // Considered sensors in this case
            for (var i = 1; i < 5; i++) {
                var con = module.getConnector(i);
                if (con) {
                    if (con['sensor_type'] === 29) continue;

                    var mod = module.get('module_number');
                    var option = { id: mod, text: module.getDisplayName(), selected: '' };
                    if (mod === App.getLastSelectedModuleNumber()) option.selected = "selected";
                    options.push(option);
                    break;
                }
            }
        });
        if (options.length) return [{ id: '', text: '' }].concat(options);
        return [{ id: '', text: 'No Modules Found' }]
    }

    private handleInstallSelectChange(e: JQuery.UIEventBase) {
        var installSelect = $(e.currentTarget);
        var installId = Number($(installSelect).val());

        if (!installId) return;

        // Save this as the last selected Id on the dashboard
        App.setLastSelectedInstallId(installId);

        var moduleSelect = installSelect.parents('.channel-selects').find('.widget-channel-select-module');
        moduleSelect.empty();

        if (this.options.permissionCollection.canViewInstall(Number(installId))) {
            if (!_.has(this.options.moduleCollections, installId)) {
                this.options.moduleCollections[installId] = new ModuleCollection([], { installId: installId });
                this.options.moduleCollections[installId].fetch();
            }

            if (this.options.moduleCollections[installId].isFetching()) {
                moduleSelect.append('<option value="">Loading...</option>');

                this.options.moduleCollections[installId].once('sync', () => {
                    moduleSelect.empty().select2(_.extend({
                        disabled: false,
                        data: this.buildModuleOptions(installId),
                    }, Utils.Select2.defaultOptions));
                    moduleSelect.trigger('change');
                });
            } else {
                moduleSelect.select2(_.extend({
                    disabled: !installId,
                    data: this.buildModuleOptions(installId),
                }, Utils.Select2.defaultOptions));
            }
        } else {
            moduleSelect.select2(_.extend({
                disabled: !installId,
            }, Utils.Select2.defaultOptions));
        }
        moduleSelect.trigger('change');
        this.checkSavable();
    }

    private handleModuleSelectChange(e: JQuery.UIEventBase) {
        var moduleSelect = $(e.currentTarget);
        var moduleNumber = (<string>$(moduleSelect).val()) || "";
        var channelSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-channel');
        var installSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-install');
        var installId = (<string>$(installSelect).val());

        // Save this as the last selected module number on the dashboard
        App.setLastSelectedModuleNumber(moduleNumber);

        channelSelect.empty();
        var channelOptions = [{ id: '', text: '' }];
        if (moduleNumber) {
            var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            if (module) {
                _.each([1, 2, 3, 4], (connector) => {
                    var con = module.getConnector(connector);
                    if (con) {
                        var label = 'Connector ' + connector + ': ' + con['sensor_name'];
                        if (!module.showConnector(connector)) label += ' (disconnected)';

                        var optgroup = { text: label, children: [] };
                        _.each(_.sortBy(con.channels, 'channel_position'), (c) => {
                            optgroup.children.push({ id: c['channel_id'], text: c['channel_name'] });
                        });

                        channelOptions.push(<any>optgroup);
                    }
                });
            }
        }
        channelSelect.select2(_.extend({
            disabled: !moduleNumber.length,
            data: channelOptions,
        }, Utils.Select2.defaultOptions));
        channelSelect.trigger('change');
        this.checkSavable();
    }

    private handleChannelSelectChange(e: JQuery.UIEventBase) {
        var channelSelect = $(e.currentTarget);
        var container = $(channelSelect).parents('.channel-selects');
        var moduleSelect = container.find('.widget-channel-select-module');
        var moduleNumber = moduleSelect.val();
        var installSelect = container.find('.widget-channel-select-install');
        var useDefaultsButton = container.find('.use-defaults-btn');

        var channelNameInput = container.find('.widget-channel-label').val('');
        var channelAggType = container.find('.widget-channel-select-aggregation-type');

        var installId = (<string>$(installSelect).val());
        var channelId = Number(channelSelect.val());

        // Clear current ranges
        const thresholdsWrapper = container.find('.thresholds-wrapper');
        thresholdsWrapper.empty();
        const channelThresholdsRow = container.find('.channel-thresholds');
        this.setMultirangeThresholdQty(channelThresholdsRow);
        useDefaultsButton.prop('disabled', true);

        if (!channelId) {
            channelNameInput.prop('disabled', true);
            channelAggType.prop('disabled', true);
            this.updateThresholdRow(container);
            return;
        }

        // Enable defaults button
        useDefaultsButton.prop('disabled', false);

        var dashbordChannelId = container.find('.widget-dashboard-channel-id').val();
        var dashboardChannel = this.options.dashboardChannelCollection.findWhere({
            dashboard_channel_id: Number(dashbordChannelId),
            dashboard_widget_id: this.options.widget.get('id'),
            channel_id: channelId
        });
        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        var channel = module.getChannelById(channelId);
        var unit = channel['channel_unit'];
        var unitField = container.find('.thresholds .unit');

        if (dashboardChannel) {
            channelNameInput.val(dashboardChannel.get('dashboard_channel_name'));
            this.updateThresholdRow(container, channelId, dashboardChannel.get('rangesList'), unit);
        } else {
            this.updateThresholdRow(container, null, null, unit);
        }

        if (channelNameInput.val() == '') {
            channelNameInput.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }

        var chartTitleField = $('.chart-title input');
        if (chartTitleField.val() === '') {
            chartTitleField.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }

        channelNameInput.prop('disabled', false);
        channelAggType.prop('disabled', false);

        unitField.val(unit);
        this.checkSavable();
    }

    private handleChannelDelete(e: JQuery.UIEventBase) {
        var channelContainer = $(e.currentTarget).parents('.channel-selects');
        // Remove elements generated by Spectrum Color Picker
        var colorPickerInputs = channelContainer.find('.threshold-range .threshold-color.color-picker');
        _.each(colorPickerInputs, (cp) => {
            var $cp = $(cp);
            (<any>$cp).spectrum("container").remove();
        });
        channelContainer.remove();
        this.checkSavable();
    }

    private handleAggregationPeriodChange() {
        this.switchAggPeriod();
        this.switchExampleImg();
        this.checkSavable();
    }

    private handleDataRangeChange() {
        var dataRange = this.$('.data-range select').val();
        this.$('.data-range-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM);
        this.$('.daily-time-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM_DAILY);
        this.$('.monthly-billing-range-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING);
    }

    private handleShowThresholdsChange() {
        this.switchExampleImg();
    }

    private handleShowLabelsChange() {
        this.switchExampleImg();
    }

    private handleThresholdsInput(e: JQuery.UIEventBase) {
        var targetInput: any = $(e.currentTarget);
        var unit = targetInput.parents('.thresholds').find('.unit').val();

        var val = (<string>targetInput.val());
        var addClass = false;
        if (val == '') {
            val = 'N/A';
        } else {
            if (_.isNaN(Number(val))) {
                val = 'N/A';
            } else {
                val += unit;
                addClass = true;
            }
        }

        var allInputs = targetInput.parents('.thresholds').find('input');
        for (var i = 0; i < allInputs.length; i++) {
            if (allInputs.eq(i).is(targetInput)) break;
        }

        var badge = targetInput.parents('.channel-thresholds').find('.threshold-badges .badge:eq(' + i + ')');
        badge.text(val);
        if (addClass) {
            if (badge.hasClass('crit-low') || badge.hasClass('crit-high')) {
                badge.addClass('danger');
            } else {
                badge.addClass('warning');
            }
        } else {
            badge.removeClass('danger').removeClass('warning');
        }
        this.checkSavable();
    }

    handleThresholdInput() {
    const canSave = this.canSaveRanges();
    if(!canSave){
        $('.modal-footer .save').prop('disabled', true);
        return;
    }
        this.checkSavable();
    }

    private handleLimitInput() {
        this.checkSavable();
    }

    private handleThresholdClick(e: JQuery.UIEventBase) {
        var thresholdsContainer = $(e.currentTarget).parents('.channel-thresholds').find('.thresholds');
        var hidden = thresholdsContainer.hasClass('hidden');
        if (hidden) {
            thresholdsContainer.removeClass('hidden');
        } else {
            thresholdsContainer.addClass('hidden');
        }
    }

    private switchAggPeriod() {
        var aggBlock = this.$('.aggregation-wrapper');
        if (!this.$('.aggregation-period select').val() ||
            this.$('.aggregation-period select').val() === '0' ||
            this.$('.chart-type select').val() === CHART_TYPE.BOX_PLOT) {

            aggBlock.css("display", "none");
        } else {
            aggBlock.css("display", "block");
            aggBlock.find('.widget-channel-select-aggregation-type').select2(Utils.Select2.defaultOptions);
            // If there is no selected option for the aggregation type, make Average - Mean (1) the default
            const aggTypes = aggBlock.find('.widget-channel-select-aggregation-type');
            aggTypes.each(function(){
                const aggTypeSelect = $(this);
                const val = aggTypeSelect.val() ?? '';
                if (!val) {
                    aggTypeSelect.val('1');
                    aggTypeSelect.trigger('change');
                }
            });
        }
    }

    private getImageName(chartType: string, period: string, showThresholds: number, showLabels: number) {
        var suffix = !showLabels || showLabels === 1 ? '_show' : '';

        var aggPeriodName = '1day';
        switch (period) {
            case '0':
            case '1':
                aggPeriodName = '1hour';
                break;
            case '2':
                aggPeriodName = '1day';
                break;
            case '3':
                aggPeriodName = '1week';
                break;
            case '4':
                aggPeriodName = '1month';
                break;
            case '5':
                aggPeriodName = '3month';
                break;
            case '6':
                aggPeriodName = '6month';
                break;
            case '7':
                // No images
                // aggPeriodName = '1year';
                break;
            case '8':
                aggPeriodName = '15minute';
                break;
            case '9':
                aggPeriodName = '30minute';
                break;
            default:
                aggPeriodName = '1day';
                break;
        }

        var imgName;
        switch (chartType) {
            case '0':
            case '1':
                if (!showThresholds || showThresholds === 1) {
                    imgName = 'c_line_show_thresholds'
                } else {
                    imgName = 'c_line_hide_thresholds'
                }
                break;
            case '2':
                imgName = 'c_bar_' + aggPeriodName;
                break;
            case '3':
                imgName = 'c_stacked_bar_' + aggPeriodName + suffix;
                break;
            case '4':
                imgName = 'c_heatmap_' + aggPeriodName + suffix;
                break;
            case '5':
                imgName = 'c_stacked_area';
                break;
            case '6':
                if (!showLabels || showLabels === 1) {
                    imgName = 'c_pie_show_labels'
                } else {
                    imgName = 'c_pie_hide_labels'
                }
                break;
            case '1,2':
                imgName = 'c_line_bar_' + aggPeriodName;
                if (!showThresholds || showThresholds === 1) imgName += "_show_thresholds";
                if (!showLabels || showLabels === 1) imgName += "_show_labels";
                break;
            case '1,3':
                imgName = 'c_line_stacked_bar_' + aggPeriodName;
                if (!showThresholds || showThresholds === 1) imgName += "_show_thresholds";
                if (!showLabels || showLabels === 1) imgName += "_show_labels";
                break;
            case '9':
                imgName = 'c_gauge';
                break;
            case '10':
                imgName = 'c_boxplot';
                break;
        }
        imgName += '.png';
        return imgName;
    }

    private getImageUrl() {
        var chartType = this.$('.chart-type select').val();
        var aggregationPeriod = Number(this.$('.aggregation-period select').val());
        var showThresholds = Number(this.$('.show-thresholds select').val());
        var showLabels = Number(this.$('.show-labels select').val());

        var imgName = this.getImageName(String(chartType), String(aggregationPeriod), showThresholds, showLabels);
        var ref;

        try {
            ref = require('../../../../../../img/widgettypes/charts/' + imgName);
        } catch (e) {
            try {
                imgName = this.getImageName(String(chartType), '2', 0, 0);
                ref = require('../../../../../../img/widgettypes/charts/' + imgName);
            } catch (e) {
                console.log("Not found: ", imgName);
                ref = require('../../../../../../img/widgettypes/charts/404.png');
            }
        }
        return ref;
    }

    private switchExampleImg() {
        this.$('.example img').attr('src', this.getImageUrl());
    }

    checkSavable() {
        var period = this.$('.aggregation-period select').val();
        var channelsForms = this.$('.channels');
        var savable = _.every(channelsForms, (form) => {
            var eachFieldHasChannel = false;
            var eachHasAgg = true;
            _.each($(form).children('.channel-selects'), (channel) => {
                var channelSelected = $(channel).find('.widget-channel-select-channel').val() !== '';
                eachFieldHasChannel = eachFieldHasChannel ? true : channelSelected;

                if (channelSelected && period !== '0') {
                    eachHasAgg = !eachHasAgg ? false : $(channel).find('.widget-channel-select-aggregation-type').val() !== '';
                }
            });
            return eachFieldHasChannel && eachHasAgg;
        });
        if (this.$('.chart-type select').val() === CHART_TYPE.GAUGE) {
            var lowerLimit = this.$(".gauge-lower-limit input").val();
            var upperLimit = this.$(".gauge-upper-limit input").val();
            if (lowerLimit === "" || upperLimit === "" || Number(lowerLimit) >= Number(upperLimit)) {
                savable = false;
            }

            //check that thresholds don't exceed min and max limits
            let thresholds = this.$('.thresholds input.form-control');
            if(this.advancedConfig) thresholds = this.$('.thresholds .threshold-value');
            _.each(thresholds, element => {
                var val = $(element).val();
                if (val === "") return;

                if (Number(val) >= Number(upperLimit) || Number(val) <= Number(lowerLimit)) {
                    savable = false;
                }
            });
        }   
        this.options.parentView.setSavable(savable);
    }

    preSave() {
        var isTall = Number(this.$('.chart-type select').val() === '6' || this.$('.chart-type select').val() === '9');

        var aggregationTypesArr = _.map(this.$('.widget-channel-select-aggregation-type'), (type) => {
            return $(type).val();
        });

        this.options.widget.setParamValue('ADVANCED_CONFIG', this.advancedConfig);
        this.options.widget.setParamValue('USE_CUSTOM_LABELS', this.useCustomLabels);
        this.options.widget.setParamValue('CHART_IS_TALL', String(isTall));
        this.options.widget.setParamValue('CHART_TITLE', this.$('.chart-title input').val());
        this.options.widget.setParamValue('CHART_TYPE', this.$('.chart-type select').val());
        this.options.widget.setParamValue('CHART_SIZE', this.$('.chart-size select').val());
        this.options.widget.setParamValue('CHART_CONNECT_TO_TILES', '2');
        this.options.widget.setParamValue('CHART_TIMESTAMPS', this.$('.timestamps select').val());
        if (this.$('.chart-type select').val() === CHART_TYPE.BOX_PLOT)
            this.options.widget.setParamValue('CHART_AGGREGATION_TYPE', ["10"].join(','));
        else
            this.options.widget.setParamValue('CHART_AGGREGATION_TYPE', aggregationTypesArr.join(','));
        this.options.widget.setParamValue('CHART_AGGREGATION_PERIOD', this.$('.aggregation-period select').val());
        this.options.widget.setParamValue('CHART_DATA_ZOOM', this.$('.data-zoom select').val());
        if (this.$('.chart-type select').val() === CHART_TYPE.GAUGE) {
            this.options.widget.setParamValue('GAUGE_LOWER_LIMIT', this.$('.gauge-lower-limit input').val());
            this.options.widget.setParamValue('GAUGE_UPPER_LIMIT', this.$('.gauge-upper-limit input').val());
        }
        this.options.widget.setParamValue('CHART_HIDE_EXPORTS',
            this.$('.chart-hide-exports input').is(':checked')
                ? CHART_HIDE_EXPORTS.DISABLED : CHART_HIDE_EXPORTS.ENABLED);
        this.options.widget.setParamValue('DAILY_TIME_MODE',
            this.$('.daily-time-mode input').is(':checked')
                ? DAILY_TIME_MODE.FULL_RANGE : DAILY_TIME_MODE.UP_TO_NOW);
        this.options.widget.setParamValue('CHART_THRESHOLDS',
            this.$('.chart-thresholds input').is(':checked')
                ? CHART_THRESHOLDS.ENABLED : CHART_THRESHOLDS.DISABLED);
        this.options.widget.setParamValue('CHART_LABELS',
            this.$('.show-labels input').is(':checked')
                ? CHART_LABELS.ENABLED : CHART_LABELS.DISABLED);
        this.options.widget.setParamValue('CHART_TIMESTAMPS',
            this.$('.chart-timestamps input').is(':checked')
                ? CHART_REAL_TIMESTAMPS.ENABLED : CHART_REAL_TIMESTAMPS.DISABLED);

        var timezone = String(this.$('.timezone select').val());
        this.options.widget.setParamValue('CHART_TIMEZONE', timezone);
        var dataRange = this.$('.data-range select').val();
        if (this.$('.chart-type select').val() === CHART_TYPE.GAUGE)
            dataRange = ChartHelper.getDataRangeEquivalent(this.$('.aggregation-period select').val());
        this.options.widget.setParamValue('CHART_DATA_RANGE', dataRange);
        this.options.widget.setParamValue('DAILY_TIME_MODE',
            this.$('.daily-time-mode input').is(':checked')
                ? DAILY_TIME_MODE.FULL_RANGE : DAILY_TIME_MODE.UP_TO_NOW);

        if (dataRange === CHART_DATA_RANGE.CUSTOM) {
            var fromMoment = String(this.$('.data-range-custom-from input').val());
            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_FROM',
                moment.tz(fromMoment, this.dateTimePickerFormat, timezone).unix()
            );

            var toMoment = String(this.$('.data-range-custom-to input').val());
            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_TO',
                moment.tz(toMoment, this.dateTimePickerFormat, timezone).unix()
            );
        } else if (dataRange !== CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING) {
            // If not custom range, remove custom times
            this.options.widget.setParamValue('CHART_DATA_RANGE_FROM', 0);
            this.options.widget.setParamValue('CHART_DATA_RANGE_TO', 0);
        }

        if (dataRange === CHART_DATA_RANGE.CUSTOM_DAILY) {
            var fromMoment = String(this.$('.daily-time-custom-from input').val());
            this.options.widget.setParamValue(
                'DAILY_TIME_FROM',
                // Get seconds from beginning of the day until the start time
                Math.abs(moment().startOf('day').unix() - moment(fromMoment, this.dailyTimeFormat).unix())
            );

            var toMoment = String(this.$('.daily-time-custom-to input').val());
            this.options.widget.setParamValue(
                'DAILY_TIME_TO',
                // Get seconds from beginning of the day until the end time
                Math.abs(moment().startOf('day').unix() - moment(toMoment, this.dailyTimeFormat).unix())
            );
        } else {
            // If not daily custom range, remove custom times
            this.options.widget.setParamValue('DAILY_TIME_FROM', 0);
            this.options.widget.setParamValue('DAILY_TIME_TO', 0);
        }

        if (dataRange == CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING) {
            var monthlyBillingDate = String(this.$('.monthly-billing-range-custom-wrapper select').val());
            this.options.widget.setParamValue('CHART_MONTHLY_BILLING_DATE', monthlyBillingDate);
            var monthlyDateTimestamp = moment().startOf('month').add(Number(monthlyBillingDate) - 1, 'day');
            var todaysDate = moment().startOf('day').format('DD');

            var fromMoment: string;
            var toMoment: string;

            if (Number(todaysDate) >= Number(monthlyBillingDate)) {
                // If the billing period ends today or earlier, have the period end the monthly billing date this month
                toMoment = moment(monthlyDateTimestamp).tz(timezone).startOf('day').format(this.dateTimePickerFormat);
                fromMoment = moment(toMoment).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
            } else {
                // Otherwise, use the last full month's data
                toMoment = moment(monthlyDateTimestamp).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
                fromMoment = moment(toMoment).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
            }

            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_FROM',
                moment.tz(fromMoment, this.dateTimePickerFormat, timezone).unix()
            );

            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_TO',
                moment.tz(toMoment, this.dateTimePickerFormat, timezone).unix()
            );

        } else if (dataRange !== CHART_DATA_RANGE.CUSTOM) {
            // If not custom range, remove custom times
            this.options.widget.setParamValue('CHART_DATA_RANGE_FROM', 0);
            this.options.widget.setParamValue('CHART_DATA_RANGE_TO', 0);
        }

        return true;
    }

    public getChannelDifference() {
        var channelsSeen = [];
        var create = [];
        var update = {};
        var fields = this.$('.channel-field');
        var i = 0;
        _.each(fields, (field, j) => {
            var rows = $(field).children('.channels').children('.channel-selects');
            _.each(rows, (row) => {
                var $row = $(row);
                var channelId = $row.find('.widget-channel-select-channel').val();

                var dashboardChannelIdField = $row.find('.widget-dashboard-channel-id');
                var dashboardChannelId = Number(dashboardChannelIdField.val());

                //If the row has no channelId, make sure not to delete it if its a result of not having permissions to view an install
                if (!channelId) {
                    channelId = $row.find('.widget-channel-select-channel').data('channelId');
                    if (channelId) channelsSeen.push(dashboardChannelId);
                    return;
                }

                channelId = Number(channelId);
                // Use default name or custom name based on configuration
                const installSelect = $row.find('.widget-channel-select-install');
                const installId = (<string>$(installSelect).val());
                const moduleNumber = $row.find('.widget-channel-select-module').val();
                const module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
                const channel = module.getChannelById(channelId);
                let name = (<string>$row.find('.widget-channel-label').val()).trim();
                if(!this.useCustomLabels) name = `${module.get('module_location')} - ${channel['channel_name']}`;
                
                var rangesList = this.advancedConfig ? this.getRangesListFromAdvancedThresholds(row) : this.getRangesListFromRegularThresholds(row);

                var upsert: NewDashboardChannel = {
                    dashboardId: this.options.dashboardId,
                    widgetId: this.options.widget.get('id'),
                    channelId: <number>channelId,
                    order: i,
                    secondary_order: j,
                    name: name,
                    critLow: null,
                    warnLow: null,
                    warnHigh: null,
                    critHigh: null,
                    rangesList: rangesList
                };
                if (dashboardChannelId) {
                    channelsSeen.push(dashboardChannelId);

                    // Make sure we had permission to update this channel
                    if (!dashboardChannelIdField.attr('data-ignore-update')) update[dashboardChannelId] = upsert;
                } else {
                    create.push(upsert)
                }
                i++;
            });
        });


        var _delete = [];
        _.each(this.widgetChannels, (c) => {
            var dcid = c.get('dashboard_channel_id');
            if (!_.includes(channelsSeen, dcid)) _delete.push(dcid);
        });

        return [create, update, _delete]
    }

    remove() {
        this.stopListening();
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/chart/ModifyChartWidgetView.ts